export const tabRoutes = {
  default: '/:page?',
  sections: '/sections',
  roles: '/roles',
  users: '/users',
  groups: '/groups',
  tags: '/tags',
  notifications: '/notifications',
};

export const sectionRoutes = {
  section: '/sections/:sectionId?/:roleId?',
};

export const roleRoutes = {
  role: '/roles/:roleId?',
};

export const userRoutes = {
  user: '/users/:userId/:roleId?',
};

export const groupRoutes = {
  group: '/groups/:groupId/:roleId?',
};

export const notificationRoutes = {
  section: '/notifications/:sectionId?',
};

export const routes = {
  home: '/',
  login: '/login',
};


export const routeGenerator = {
  sectionLink: (sectionId, roleId) => {
    let link = `${sectionRoutes.section.replace(':sectionId?', sectionId)}`;
    if (roleId) {
      link = link.replace(':roleId?', roleId);
    } else {
      link = link.replace('/:roleId?', '');
    }
    return link;
  },
  userRoleLink: (userId, roleId) => {
    let link = `${userRoutes.user.replace(':userId', userId)}`;
    if (roleId) {
      link = link.replace(':roleId?', roleId);
    } else {
      link = link.replace('/:roleId?', '');
    }
    return link;
  },
  groupRoleLink: (groupId, roleId) => {
    let link = `${groupRoutes.group.replace(':groupId', groupId)}`;
    if (roleId) {
      link = link.replace(':roleId?', roleId);
    } else {
      link = link.replace('/:roleId?', '');
    }
    return link;
  },
  roleEditLink: roleId => `${roleRoutes.role.replace(':roleId', roleId)}`,
  userEditLink: userId => `${userRoutes.user.replace(':userId', userId)}`,
  notificationEditLink: sectionId => `${notificationRoutes.section.replace(':sectionId?', sectionId)}`,
};



// WEBPACK FOOTER //
// ./src/routes.js